<template>
  <div class="d-flex align-center flex-grow-1">
    <div :class="[display.smAndDown ? 'mr-2': 'mr-3']">
      <EmAvatar
        :name="name"
        :phone-number="phoneNumber"
        :size="display.smAndDown ? 'small' : 'medium'"
      />
    </div>
    <div :data-cy="dataCy">
      <div v-if="name">
        <EmBody2 bold :data-cy="`${dataCy}--name`" class="max-lines-1 text-no-wrap">
          {{ name }}
        </EmBody2>
      </div>
      <div>
        <EmPhoneNumber
          :data-cy="`${dataCy}--phone`"
          :phone="phoneNumber"
        >
          <template #phone>
            <EmPhoneNumberName
              :name="name"
              :phone-number="phoneNumber"
            />
          </template>
        </EmPhoneNumber>
      </div>
    </div>
    <div v-if="nameSource" class="ml-2">
      <EmTooltip force-tooltip :open-on-click="display.mobile">
        <template #activator="{attrs, props}">
          <EmIcon
            icon="mdi-information"
            color="primary"
            v-bind="{...attrs, ...$attrs, ...props}"
            class="ml-2"
          />
        </template>
        <span class="d-inline-block text-wrap">
          {{ getNameSourceText(nameSource) }}
        </span>
      </EmTooltip>
    </div>
  </div>
</template>
<script setup>
import { useDisplay } from 'vuetify'
const display = ref(useDisplay())
const { getNameSourceText } = useNameSource()
defineProps({
  name: { type: String, default: null },
  phoneNumber: { type: String, default: null },
  dataCy: { type: String, default: null },
  nameSource: { type: String, default: '' }
})
</script>
<style scoped>
.text-wrap {
  max-width: 250px;
  white-space: normal;
}
</style>
